module.exports = __webpack_public_path__ + "img/gatsby.4a26dc0a.jpg";